import { isNull } from "../../helpers";
import { closeAllElements } from "../../actions/common";
export default function (store, { id }) {
    if ((!store.existsProject(id) && !isNull(id)) || typeof id === "undefined")
        return;
    closeAllElements(store);
    const { treeTasks, childrenMap, filteredChildrenMap } = store.getInnerState(store.getState().tasks, id);
    store.setState({
        activeProject: id,
        treeTasks,
        childrenMap,
        filteredChildrenMap,
    });
}
//# sourceMappingURL=set.js.map